// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-div[data-v-7e86156c] {\n  width: auto;\n  padding: 6px 20px;\n  text-align: left;\n  margin-left: 17%;\n}\n.lblTitle[data-v-7e86156c] {\n  font-size: 1.75rem !important;\n  font-weight: 700;\n  color: #00368f;\n}\n", ""]);
// Exports
module.exports = exports;
